import React from "react";
import {
  Avatar,
  Button,
  Col,
  Dropdown,
  Image,
  Modal,
  Row,
  Select,
  Space,
  Tooltip,
  message,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import withRouter from "../withRouter";

import dayjs from "dayjs";
import CompanyStore from "../store/CompanyStore";

import Cookies from "universal-cookie";
import VehicleOdometerRecordsStore from "../store/VehicleOdometerRecordsReports";
import { Link } from "react-router-dom";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import backIcon from "../assets/images/NewDesign/back-grey.svg";
import processIcon from "../assets/images/NewDesign/process-grey.svg";
import deleteIcon from "../assets/images/NewDesign/delete-grey.svg";
import { CloseOutlined } from "@ant-design/icons";

class VehicleOdometerRecords extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.odometerRecordsStore = new VehicleOdometerRecordsStore();

    this.companyStore = new CompanyStore();
    this.cookies = new Cookies();
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      showDeleteModal: false,
      showProcessDataModal: false,
      showAlertModal: false,
      selectedVehicle: "",
      companyId: "",
      loadData: 0,
      offset: 0,
      limit: 50,
      selectvehProData: [],
    };

    this.columns = [
      {
        // title: "Account",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_CUSTOMER_"),
        dataIndex: "company",
        width: 30,
      },
      {
        // title: " Asset Name",
        title: context.translate("_FLEET_REPORTS_VEHICLENO_"),
        dataIndex: "vehicleNo",
        width: 25,
      },

      {
        // title: "Change Odometer",
        title: context.translate("_CHANGE_ODOMETER_"),
        dataIndex: "odometer",
        width: 20,
      },
      {
        // title: "Date Time  ",
        title: context.translate("_DATE_TIME_"),
        dataIndex: "datetime",
        width: 25,
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
      {
        // title: "Date Time  ",
        title: context.translate("_CREATED_DATE_"),
        dataIndex: "createDate",
        width: 20,
        render: (value) => {
          if (value) {
            const formattedDateTime = dayjs(value).format(
              "DD-MM-YYYY hh:mm:ss A"
            );
            return <>{formattedDateTime}</>;
          } else {
            return <></>;
          }
        },
      },
    ];

    this.ExportMenuProps = {
      items: [
        {
          label: (
            <Link style={{ textDecoration: "none" }} to="/vehicleodometerlist">
              {" "}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {" "}
                <Avatar
                  style={{ height: "16px", width: "19px", borderRadius: "0px" }}
                  src={backIcon}
                ></Avatar>
                {context.translate("_BACK_")}
              </div>
            </Link>
          ),
          key: "back",
        },

        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async () => {
                this.state.selectedVehicle.length > 0
                  ? await this.setState({ showDeleteModal: true })
                  : await this.setState({ showAlertModal: true });
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "17px", borderRadius: "0px" }}
                src={deleteIcon}
              ></Avatar>
              {context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
            </div>
          ),
          key: "delete",
        },

        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={async () => {
                this.state.selectvehProData.length > 0
                  ? await this.setState({ showProcessDataModal: true })
                  : await this.setState({ showAlertModal: true });
                if (this.state.selectvehProData.length > 0) {
                  await this.handleOdometerProcessData();
                }
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "19px", borderRadius: "0px" }}
                src={processIcon}
              ></Avatar>
              {context.translate("_PROCESS_DATA_")}
            </div>
          ),
          key: "processdata",
        },
      ],
    };
  }

  async componentDidMount() {
    // console.log(this.viewStateStore.)
    if (Number(this.props.getUserData().isadmin) !== -1) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });

      await this.handleSearch();
    }

    this.setState({ pageSize: 50 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ companyVal_Lab: singleData });
    // await this.setState({ companyId: comp.value });
    await this.setState({ selectedVehicles: "" });

    await this.setState({ loadData: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.odometerRecordsStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      issuperadmin: this.props.getUserData().issuperadmin,
    });

    await this.setState({ loadData: 1 });
  }

  handleOdometerProcessData = async () => {
    const data = {
      recId: this.state.selectvehProData,
    };
    const response = await this.odometerRecordsStore.processOdometerData(data);
    // console.log(response);

    if (response?.success == "S") {
      message.success(response.message);
    } else {
      message.error(
        response.message ? response.message : response.errors[0][0]
      );
    }
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.odometerRecordsStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  deleteMultipleVehicles = async () => {
    const data = {
      recId: this.state.selectvehProData,
    };
    const response = await this.odometerRecordsStore.delete(data);
    console.log(response);

    if (response?.success == "S") {
      message.success(response.message);
      await this.handleSearch();
    } else {
      message.error(response.errors[0][0]);
    }
  };

  render() {
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_ODOMETER_RECORDS_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Link to="/vehicleodometerlist">
                  <Button>{this.context.translate("_BACK_")}</Button>{" "}
                </Link>

                <Button
                  onClick={async () => {
                    this.state.selectedVehicle.length > 0
                      ? await this.setState({ showDeleteModal: true })
                      : await this.setState({ showAlertModal: true });
                  }}
                >
                  <i class="bi bi-trash3" style={{ marginRight: "5px" }}></i>
                
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>

                <Button
                  onClick={async () => {
                    this.state.selectvehProData.length > 0
                      ? await this.setState({ showProcessDataModal: true })
                      : await this.setState({ showAlertModal: true });

                    await this.handleOdometerProcessData();
                  }}
                >
                  {this.context.translate("_PROCESS_DATA_")}
                </Button>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  // allowClear={true}
                  onChange={(value) => {
                    this.handleChange(value);
                  }}
                  style={{ width: 200 }}
                />
              </Space>
            </Col>
            <Col span={8}>
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
                <Tooltip title={this.context.translate("_REFRESH_")}>
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      marginInlineEnd: "20px",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Dropdown
                  overlayClassName="export-dropdown"
                  menu={this.ExportMenuProps}
                >
                  <Image
                    style={{
                      height: 18,
                      alignItems: "center",
                      cursor: "pointer",
                      // marginInlineEnd: "20px",
                    }}
                    src={kebabIcon}
                  ></Image>
                </Dropdown>
              </Space>
            </Col>
          </Row>

          <ListTable
            rowSelection={{
              columnWidth: 4,
              fixed: true,
              selectedRowKeys: this.state.selectedVehicle,
              onChange: async (selectedRowKeys, selectedRows) => {
                const selectedIds = selectedRows.map((row) => row.id);
                await this.setState({
                  selectedVehicle: selectedRowKeys,
                  selectvehProData: selectedIds, // selectedRowKeys,
                });
              },
            }}
            // value={this.state.selectedRowKeys}
            rowKey="id"
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.odometerRecordsStore?.total}
            columns={this.columns}
            dataSource={this.odometerRecordsStore?.odometerData}
            loading={this.odometerRecordsStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.showDeleteModal && (
            <Modal
              maskClosable={false}
              title={
                <div className="deleteModalTitle">
                  <span>
                    {" "}
                    {this.context.translate(
                      "_FLEET_COMPANY_COMPANYLIST_DELETE_"
                    )}
                  </span>
                  <CloseOutlined
                    style={{ cursor: "pointer", color: "white" }}
                    onClick={() => this.setState({ showDeleteModal: false })}
                  />
                </div>
              }
              className="deleteModal"
              description="Are you sure you want to delete this Item? This action cannot be undone."
              centered
              open={
                this.state.selectedVehicle.length !== 0 &&
                this.state.showDeleteModal
              }
              footer={null}
              width={400}
              closable={false}
            >
              <div className="deleteModalText">
                <p>{this.context.translate("_DELETE_STATUS_")}</p>
              </div>
              <div className="deleteModalButtons">
                <Button
                  className="deleteModalCancelButton"
                  onClick={() => this.setState({ showDeleteModal: false })}
                >
                  {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                </Button>

                <Button
                  className="deleteModalOkButton"
                  onClick={(e) => {
                    this.deleteMultipleVehicles();

                    this.setState({
                      showDeleteModal: false,
                      selectedVehicle: "",
                    });
                  }}
                >
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </Button>
              </div>
            </Modal>
          )}
        </div>

        <Modal
          maskClosable={false}
          title={
            <div className="deleteModalTitle">
              <span> {this.context.translate("_FLEET_ALERT_")}</span>
              <CloseOutlined
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.setState({ showAlertModal: false })}
              />
            </div>
          }
          className="deleteModal"
          description="Please select vehicles."
          centered
          open={this.state.showAlertModal}
          footer={null}
          width={400}
          closable={false}
        >
          <div className="deleteModalText">
            <p>
              {" "}
              {this.state.showDeleteModal
                ? this.context.translate("_SELECT_VEHICLES_")
                : this.context.translate("_SELECT_RECORD_")}
            </p>
          </div>
          <div>
            <Button
              className="deleteModalCancelButton"
              onClick={() => this.setState({ showAlertModal: false })}
            >
              {this.context.translate("_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_")}
            </Button>
          </div>
        </Modal>
      </>
    );
  }
}
VehicleOdometerRecords.contextType = StoreContext;
export default observer(withRouter(VehicleOdometerRecords));

{
  /* <Modal
width={350}
className="alert-model"
title={
  <div>
    {" "}
    <i
      style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
      class="bi bi-exclamation-triangle"
    ></i>{" "}
    {this.context.translate("_FLEET_ALERT_")}
  </div>
}
open={this.state.showAlertModal}
onOk={() => this.setState({ showAlertModal: false })}
onCancel={() => this.setState({ showAlertModal: false })}
okText="OK"
cancelText="Cancel"
footer={[
  <Button
    type="primary"
    onClick={() => this.setState({ showAlertModal: false })}
  >
    {this.context.translate(
      "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
    )}
  </Button>,
]}
>
{this.state.showDeleteModal
  ? this.context.translate("_SELECT_VEHICLES_")
  : this.context.translate("_SELECT_RECORD_")}
</Modal> */
}
